type Entity = {
  position: [number, number];
  size: [number, number];
};

export function collidesWithEntity(entity1: Entity, entity2: Entity): boolean {
  const [x, y] = entity1.position;
  const [w, h] = entity1.size;
  const [r, b] = [x + w, y + h];
  const [x2, y2] = entity2.position;
  const [w2, h2] = entity2.size;
  const [r2, b2] = [x2 + w2, y2 + h2];

  return !(r <= x2 || x > r2 || b <= y2 || y > b2);
}
